import {
  FlashMapNodeMetricValue,
  FlashMapOptions,
  FlashMapNode,
} from '../models/types';

export interface NodeRenderContext {
  jm: unknown;
  ele: HTMLElement;
  node: FlashMapNode;
  options: Partial<FlashMapOptions>;
  emitFlashcardClick?: (nodeId: string, count: number) => void;
  getNodeMetrics?: (nodeId: string) => FlashMapNodeMetricValue;
}

export interface NodeRenderResult {
  handled: boolean;
  continue: boolean;
}

export interface NodeRenderer {
  render(context: NodeRenderContext): NodeRenderResult;
}

export const continueChain: NodeRenderResult = { handled: false, continue: true };

export const stopChain: NodeRenderResult = { handled: true, continue: false };
